import { Generic } from './Padding';
export function isPadding(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isPadding;    //# sourceMappingURL=isPadding.js.map
